"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseAccountAuthConfig = parseAccountAuthConfig;
exports.parseAccountAuthResult = parseAccountAuthResult;
const fail = () => { throw new TypeError("Invalid account authentication response"); };
function exact(v, keys, optional = []) {
    if (!v || typeof v !== "object" || Array.isArray(v))
        return fail();
    const r = v;
    if (keys.some(k => !Object.prototype.hasOwnProperty.call(r, k)) || Object.keys(r).some(k => !keys.includes(k) && !optional.includes(k)))
        return fail();
    return r;
}
function str(v, max = 255) { if (typeof v !== "string" || !v || v.length > max || v.trim() !== v || /[\u0000-\u001f\u007f]/.test(v))
    return fail(); return v; }
function bool(v) { return typeof v === "boolean" ? v : fail(); }
function int(v, max = Number.MAX_SAFE_INTEGER) { return typeof v === "number" && Number.isSafeInteger(v) && v >= 0 && v <= max ? v : fail(); }
function token(v) { const s = str(v, 43); return /^[A-Za-z0-9_-]{43}$/.test(s) ? s : fail(); }
function date(v) { const s = str(v, 35); if (!/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.\d{3})?Z$/.test(s) || !Number.isFinite(Date.parse(s)))
    return fail(); return new Date(s).toISOString() === (s.includes(".") ? s : s.replace("Z", ".000Z")) ? s : fail(); }
function mfa(v) { const r = exact(v, ["kind", "challengeToken", "expiresAt"]); return { kind: "MFA_REQUIRED", challengeToken: token(r.challengeToken), expiresAt: date(r.expiresAt) }; }
function parseAccountAuthConfig(v) { const r = exact(v, ["emailEnabled", "authenticatorEnabled"]); return { emailEnabled: bool(r.emailEnabled), authenticatorEnabled: bool(r.authenticatorEnabled) }; }
function parseAccountAuthResult(op, v) {
    let result;
    if (op === "email/request" || op === "security/enrollment/request") {
        const r = exact(v, ["challengeToken", "expiresAt", "resendAfterSeconds"]);
        result = { challengeToken: token(r.challengeToken), expiresAt: date(r.expiresAt), resendAfterSeconds: int(r.resendAfterSeconds, 86400) };
    }
    else if (op === "security/status") {
        const r = exact(v, ["available", "email", "authenticatorEnabled", "recoveryCodesRemaining", "recentAuthentication"]), email = r.email === null ? null : str(r.email, 320);
        if (email !== null && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))
            return fail();
        result = { available: bool(r.available), email, authenticatorEnabled: bool(r.authenticatorEnabled), recoveryCodesRemaining: int(r.recoveryCodesRemaining, 20), recentAuthentication: bool(r.recentAuthentication) };
    }
    else if (op === "security/enrollment/verify") {
        const r = exact(v, ["enrollmentToken", "secret", "otpauthUri", "qrDataUrl", "expiresAt"]), secret = str(r.secret, 128), otpauthUri = str(r.otpauthUri, 4096), qrDataUrl = str(r.qrDataUrl, 262144);
        if (!/^[A-Z2-7]{16,128}$/.test(secret) || !/^data:image\/png;base64,[A-Za-z0-9+/]+={0,2}$/.test(qrDataUrl))
            return fail();
        let uri;
        try {
            uri = new URL(otpauthUri);
        }
        catch {
            return fail();
        }
        if (uri.protocol !== "otpauth:" || uri.hostname !== "totp" || uri.username || uri.password || uri.port || uri.hash || !uri.pathname.slice(1) || uri.searchParams.getAll("secret").length !== 1 || uri.searchParams.get("secret") !== secret)
            return fail();
        result = { enrollmentToken: token(r.enrollmentToken), secret, otpauthUri, qrDataUrl, expiresAt: date(r.expiresAt) };
    }
    else if (op === "session-policy") {
        const r = exact(v, ["allowed"]);
        result = { allowed: bool(r.allowed) };
    }
    else if (op === "exchange-policy") {
        const r = exact(v, ["kind"], ["authenticationSessionId", "securityVersion", "challengeToken", "expiresAt"]);
        if (r.kind === "MFA_REQUIRED")
            result = mfa(r);
        else if (r.kind === "EMAIL_REQUIRED") {
            exact(r, ["kind"]);
            result = { kind: "EMAIL_REQUIRED" };
        }
        else if (r.kind === "ALLOWED") {
            exact(r, ["kind"], ["authenticationSessionId", "securityVersion"]);
            if ((r.authenticationSessionId === undefined) !== (r.securityVersion === undefined))
                return fail();
            const id = r.authenticationSessionId === undefined ? undefined : str(r.authenticationSessionId, 36);
            if (id !== undefined && !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(id))
                return fail();
            result = { kind: "ALLOWED", ...(id === undefined ? {} : { authenticationSessionId: id, securityVersion: int(r.securityVersion) }) };
        }
        else
            return fail();
    }
    else {
        const r = exact(v, ["kind"], ["customToken", "recoveryCodes", "challengeToken", "expiresAt"]);
        if (r.kind === "MFA_REQUIRED")
            result = mfa(r);
        else if (r.kind === "SIGNED_IN") {
            exact(r, ["kind", "customToken"], ["recoveryCodes"]);
            const customToken = str(r.customToken, 16384);
            if (!/^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/.test(customToken))
                return fail();
            let recoveryCodes;
            if (r.recoveryCodes !== undefined) {
                if (!Array.isArray(r.recoveryCodes) || !r.recoveryCodes.length || r.recoveryCodes.length > 20)
                    return fail();
                recoveryCodes = r.recoveryCodes.map(c => { const s = str(c, 128); return /^[A-Za-z0-9_-]{6,128}$/.test(s) ? s : fail(); });
                if (new Set(recoveryCodes).size !== recoveryCodes.length)
                    return fail();
            }
            result = { kind: "SIGNED_IN", customToken, ...(recoveryCodes ? { recoveryCodes } : {}) };
        }
        else
            return fail();
    }
    return result;
}
//# sourceMappingURL=account-auth.js.map